module.exports = __webpack_public_path__ + "img/Ident-Process-7.cc604559.png";